import { useMediaQuery } from '@mui/material';

export const useIsTouchDevice = () =>
  useMediaQuery('(hover: none) and (pointer: coarse)');
